module.exports = __webpack_public_path__ + "static/media/IMG_0029.71a1f690.jpg";